import React from "react";
import SearchableDropdown from "./SearchableDropdown";
import { useESS } from "../../Pages/ESS/Hooks/useESS";

const CommonFilter = (props) => {
  const { getUsers } = useESS();
  const {
    title = "Filter",
    tempFilters,
    setTempFilters,
    onApply,
    onClear,
    onCancel,
    statusOptions = [],
    siteOptions = [],
    typeOptions = [],
    categoryOptions = [],
    assignee = false,
    date = false,
    useSearchableUser = false,
    customLabel = "",
    setUserFilterField = "",
    filtersConfig = [],
    allowMonthFilter = false,
    selectedSearchableValue = null,
    categoryLabel = "Category",
  } = props;
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-md mx-4 rounded-2xl shadow-xl p-6 relative overflow-y-auto">
        <h3 className="text-lg font-semibold text-primary mb-4">{title}</h3>

        <div className="flex flex-col gap-4">
          {/* Status Dropdown */}
          {statusOptions.length !== 0 && (
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Status
              </label>
              <select
                value={tempFilters.status || ""}
                onChange={(e) =>
                  setTempFilters((prev) => ({
                    ...prev,
                    status: e.target.value,
                  }))
                }
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-primary focus:outline-none"
              >
                {statusOptions.map((status) => (
                  <option key={status.value} value={status.value}>
                    {status.label.charAt(0).toUpperCase() +
                      status.label.slice(1).replace(/_/g, " ")}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Category Dropdown */}
          {categoryOptions.length !== 0 && (
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                {categoryLabel}
              </label>
              <select
                value={tempFilters.category || ""}
                onChange={(e) =>
                  setTempFilters((prev) => ({
                    ...prev,
                    category: e.target.value,
                  }))
                }
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-primary focus:outline-none"
              >
                {categoryOptions.map((status) => (
                  <option key={status.value} value={status.value}>
                    {status.label.charAt(0).toUpperCase() +
                      status.label.slice(1).replace(/_/g, " ")}
                  </option>
                ))}
              </select>
            </div>
          )}
          {useSearchableUser && (assignee || !assignee) && (
            <SearchableDropdown
              label={assignee ? "Assignee" : customLabel ? customLabel : "User"}
              fetchFunction={({ search }) => getUsers({ mode: "all", search })}
              onSelect={(value) =>
                setTempFilters((prev) => ({
                  ...prev,
                  [assignee
                    ? "assignee"
                    : setUserFilterField
                      ? setUserFilterField
                      : "user"]: value,
                }))
              }
              valueKey="id"
              labelKey="full_name"
              placeholder={assignee ? "Select Assignee" : "Select User"}
              includeAllOption={true}
              allOptionLabel={assignee ? "All Assignees" : "All Users"}
              value={selectedSearchableValue}
            />
          )}
          {/* Date Picker */}
          {!assignee && date && (
            <>
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Date
                </label>
                <input
                  type="date"
                  value={tempFilters.date || ""}
                  onChange={(e) =>
                    setTempFilters((prev) => ({
                      ...prev,
                      date: e.target.value,
                    }))
                  }
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-primary focus:outline-none"
                />
              </div>
            </>
          )}

          {/* Month Filter */}
          {allowMonthFilter && (
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Month
              </label>
              <input
                type="month"
                value={tempFilters.month || ""}
                onChange={(e) =>
                  setTempFilters((prev) => ({
                    ...prev,
                    month: e.target.value,
                  }))
                }
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-primary focus:outline-none"
              />
            </div>
          )}

          {/* Type Dropdown (shown only if not assignee) */}
          {!assignee && typeOptions.length > 0 && (
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Type
              </label>
              <select
                value={tempFilters["category__type"] || ""}
                onChange={(e) =>
                  setTempFilters((prev) => ({
                    ...prev,
                    category__type: e.target.value,
                  }))
                }
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-primary focus:outline-none"
              >
                <option value="">All</option>
                {typeOptions.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Site Dropdown (shown only if not assignee) */}
          {!assignee && siteOptions.length > 0 && (
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Site
              </label>
              <select
                value={tempFilters.site || ""}
                onChange={(e) =>
                  setTempFilters((prev) => ({
                    ...prev,
                    site: e.target.value,
                  }))
                }
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-primary focus:outline-none"
              >
                <option value="">All</option>
                {siteOptions.map((site) => (
                  <option key={site.id} value={site.id}>
                    {site.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {filtersConfig.map((filter) => {
            if (filter.type === "boolean") {
              return (
                <div key={filter.key} className="flex flex-col">
                  <label className="text-sm font-medium text-gray-700 mb-1">
                    {filter.label}
                  </label>
                  <select
                    value={tempFilters[filter.key] || ""}
                    onChange={(e) =>
                      setTempFilters((prev) => ({
                        ...prev,
                        [filter.key]: e.target.value,
                      }))
                    }
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-primary focus:outline-none"
                  >
                    <option value="">All</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              );
            }

            return null;
          })}

          {/* Action Buttons */}
          <div className="flex justify-between items-center mt-4">
            <button
              className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-800 text-sm"
              onClick={onClear}
            >
              Clear
            </button>
            <div className="flex gap-2">
              <button
                className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-sm text-gray-800"
                onClick={onCancel}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-lg bg-primary hover:bg-green-600 text-white text-sm"
                onClick={onApply}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonFilter;
